export const getLtDateQueryPart = (dateLimit: number | undefined) =>
  getDateQueryPart(dateLimit, 'lt')

export const getGtDateQueryPart = (dateLimit: number | undefined) =>
  getDateQueryPart(dateLimit, 'gt')

const getDateQueryPart = (dateLimit: number | undefined, operator: string) => {
  return dateLimit !== undefined && !isNaN(dateLimit)
    ? `timestamp_${operator}:${dateLimit}`
    : `timestamp_${operator}:${dateLimit}`
}
